module.exports = __webpack_public_path__ + "img/home.91707ef3.png";